import styled from 'styled-components';

export default styled.section`
	border-radius: 0.8rem;
	border: solid 1px ${(props) => props.theme.color[`grey300`]};
	--space-left: 0;
	--space-right: 0;
	--bg: ${({theme}) => theme.color[`white`]};
	min-height: 10rem;
	width: calc(100% + var(--space-left) + var(--space-right));
	margin-left: calc(var(--space-left) * -1);
	margin-bottom: var(--space-left);
	padding: 0 var(--space-right) 0 var(--space-left);
	background: var(--bg);
	.motif-loader-container {
		background: var(--bg);
	}

	.chart-heading {
		border-top-left-radius: 0.8rem;
		border-top-right-radius: 0.8rem;
		border-bottom: var(--table--border-style) var(--table--border-width) var(--table--border-color);
	}
`;
